import DataTableColumnBase, { DataTableColumnBaseProps } from './DataTableColumnBase';

export interface DataTableCustomColumnProps<V = any> extends DataTableColumnBaseProps {
    render: (item: V) => React.ReactNode;
}

export default class DataTableCustomColumn<V = any> extends DataTableColumnBase<DataTableCustomColumnProps<V>> { }
